import { isValidNumber } from 'libphonenumber-js';
import validator from 'validator';
import PageModel from '@mm/state/model/PageModel';

export const validateButtonConfigForm = ({
  url = '',
  phone = '',
  name = '',
  page = null as null | PageModel,
  appId = '',
}) => {
  const errors: { [k: string]: string } = {};

  const substitutedUrl = url.replace(/\{\{.+?\}\}/g, 'VALUE');
  if (
    !validator.isURL(substitutedUrl, {
      require_protocol: false,
      protocols: ['http', 'https'],
    })
  ) {
    errors.url = 'Incorrect url';
  }

  if (!phone) {
    errors.phone = 'Phone number required';
  } else if (!isValidNumber(phone)) {
    errors.phone = 'Invalid phone number';
  }

  if (!validator.isLength(name.trim(), { min: 1 })) {
    errors.name = 'Name should be at least 1 char long';
  }

  if (page === null) {
    errors.page = 'Page cannot be blank';
  }

  if (!appId) {
    errors.appId = 'App ID cannot be blank';
  }

  return errors;
};
